module.exports = __webpack_public_path__ + "img/vai_logo.edc65222.png";